import { useTranslate } from '@festina-life/ui/hooks'

import { useBaseBranchWorkspaces } from '../../../../hooks/useBaseBranchWorkspaces'
import { useWorkspaceOperations } from '../../../../uiModels/workspace/useWorkspaceOperations'
import { useRequiredBranchOperationsContext } from '../../../../workspace/operationsContext'
import { OperationsWithErrors } from '../../../errorsPanel/OperationsWithErrors'
import { DownloadWorkspaceButton } from '../../../workspacesPanel/workspaceDetails/manageWorkspace/DownloadWorkspaceButton'
import { PushWorkspaceToBranchForm } from '../../../workspacesPanel/workspaceDetails/manageWorkspace/PushWorkspaceToBranchForm'
import { UploadWorkspaceButton } from '../../../workspacesPanel/workspaceDetails/manageWorkspace/UploadWorkspaceButton'

export const WorkspaceChangesPanel = () => {
  const translate = useTranslate()
  const { branchKey, workspaceKey } = useRequiredBranchOperationsContext()
  const { data: draftOperations } = useWorkspaceOperations(workspaceKey)
  const hasDraftOperations = !!draftOperations.length
  const branchWorkspaces = useBaseBranchWorkspaces(branchKey)
  const isUnifiedWorkspaceBranch = branchWorkspaces?.length <= 1

  return (
    <div className="flex flex-col h-full p-1 divide-y divide-slate-200 dark:divide-slate-700">
      {workspaceKey && (
        <div className="flex-1 overflow-auto">
          <OperationsWithErrors variant="operations" className="p-1" />
        </div>
      )}
      <div className="flex gap-2 justify-end py-2">
        {workspaceKey && <DownloadWorkspaceButton />}
        {(workspaceKey || isUnifiedWorkspaceBranch) && (
          <UploadWorkspaceButton />
        )}
      </div>
      {hasDraftOperations && (
        <PushWorkspaceToBranchForm
          buttonText={translate('workspaceManagement.button.save')}
        />
      )}
    </div>
  )
}
